import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_CREDIT, CREATE_CREDIT, UPDATE_CREDIT} from 'admin/gql/Credit.gql'
import clearCache from './clearCache'
import useDestroyable from 'admin/hooks/useDestroyable'

export default (organisationId, accountId, creditId) => {
  const {data: {credit = {}} = {}, error: getError} = useQuery(GET_CREDIT, {
    variables: {organisationId, creditId},
    skip: !creditId
  })

  const [create, {error: createError}] = useMutation(CREATE_CREDIT, {
    variables: {organisationId, accountId},
    flash: 'Credit created',
    update: (cache, {errors}) => !errors && clearCache({statement: {accountId}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_CREDIT, {
    variables: {organisationId, accountId, creditId},
    flash: 'Credit updated',
    update: (cache, {errors}) =>
      !errors &&
      clearCache({
        history: {itemType: 'Credit', itemId: creditId},
        statement: {accountId}
      })(cache)
  })

  const {destroy, errors: destroyError} = useDestroyable('Credit', creditId)

  return {
    credit,
    errors: getError || createError || updateError || destroyError || {},
    create,
    update,
    destroy
  }
}
